module.exports = __webpack_public_path__ + "static/img/draw-bg.ed73f1f4.png";